import { Quill } from 'react-quill-new'
import QuillBetterTable from 'quill-better-table'

// Register the better-table module once
Quill.register({ 'modules/better-table': QuillBetterTable }, true)

// Provide a raw SVG icon string
const customIcons = Quill.import('ui/icons')
customIcons.insertTable = `
  <svg
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="table"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 
             17.7 14.3 32 32 32h832c17.7 0 32-14.3 
             32-32V192c0-17.7-14.3-32-32-32zm-40 
             208H676V232h212v136zm0 224H676V432h212v160zM412 
             432h200v160H412V432zm200-64H412V232h200v136zm-476 
             64h212v160H136V432zm0-200h212v136H136V232zm0 
             424h212v136H136V656zm276 
             0h200v136H412V656zm476 136H676V656h212v136z" />
  </svg>
`

// Define a handler for inserting tables
function tableHandler() {
    const quill = this.quill
    const tableModule = quill.getModule('better-table')
    tableModule.insertTable(3, 3) // 3×3 table by default
}

// Export Quill modules configuration
export const modules = {
    'better-table': {
        operationMenu: {
            items: {
                unmergeCells: {
                    text: 'Unmerge cells',
                },
            },
        },
    },
    toolbar: {
        container: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code', 'code-block'],
            ['link', 'video'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [false, 1, 2, 3] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['insertTable'],
        ],
        handlers: {
            insertTable: tableHandler,
        },
    },
    clipboard: { matchVisual: false },
}
